import wordmark from '../../assets/citilight-wordmark.png';
import { cn } from '../../lib/cn';

interface CompanyLogoProps {
  /** Rendered height in px; width follows the artwork's proportions. */
  height?: number;
  /** White on dark surfaces such as the band; the artwork itself is black. */
  inverse?: boolean;
  className?: string;
}

/** The Citilight wordmark (company artwork, black on transparent). */
export function CompanyLogo({ height = 18, inverse = false, className }: CompanyLogoProps) {
  return (
    <img
      src={wordmark}
      alt="Citilight"
      height={height}
      style={{ height }}
      className={cn('block w-auto flex-none select-none', inverse && 'brightness-0 invert', className)}
      draggable={false}
    />
  );
}
